module.exports = __webpack_public_path__ + "static/media/icon_main.e6043572.png";